<template>
  <div>
    <div class="my-exam">
      <router-link class="my-exam__a" to="/user/myClassroom">我的班级</router-link>
      <router-link class="my-exam__aa" to="/user/myCourse">我的课程</router-link>
      <!-- <router-link class="my-exam__a" to="/user/myExam">练习中心</router-link> -->
    </div>
    <ks-page-scroll-container v-if="list.length" :page="page" :pagination="pagination" :page-count="pageCount" @page-change="getMyCourseList">
      <ks-box :title="'全部课程（'+len+'）'">
                <div class="mybox__item" v-for="(item,index) in list" :key="item.countpid">
                  <div class="mybox-img">
                      <img :src="item.courseimg"/>
                  </div>
                  <div class="mybox-right ks-line">
                    <div class="mybox-right__title">{{item.coursename}}</div>
                      <div class="mybox-right__teacher">{{item.teacher}}</div>
                      <van-button class="bottom-btn" size="mini" round type="danger" @click="getCourseData(item.courseid)">资料</van-button>
                      <van-progress class="mylist-content__progress" :show-pivot="false" color="#f44" :percentage="item.has_learnpercent"/>
                      <div class="mybox-right__percentage">{{item.has_learnpercent*100}}%</div>
                      <div class="van-hairline--bottom" v-if="index+1 < list.length"></div>
                  </div>
              </div>
      </ks-box>
    </ks-page-scroll-container>
      <div class="ks-empty" v-else-if="loaded">
        <img class="ks-empty__img" src="@/assets/user/tips.png">
        暂无数据
      </div>
    <van-actionsheet v-model="show" title="课程资料">
      <div class="course" v-for="data in dataList" :key="data.zl_id">
        <div class="course-ast">{{data.zl_name}}<img class="course-ast_dload" @click="kjdownload()" src="@/assets/user/download.png"></div><div class="ks-line"></div>
      </div>
    </van-actionsheet>
    <!-- <van-actionsheet v-model="show2" title="试卷资料">
       <div class="course">
        <div class="course-ast">{{papertitle}}<img class="course-ast_dload" @click="sjdownload()" src="@/assets/user/download.png"></div><div class="ks-line"></div>
      </div>
    </van-actionsheet> -->
</div>
</template>
<script>
	import {GetCourseDataList,GetMyCourseList,GetCoursePaperList} from '@/apis/user'
export default{
  name:'myCourse',
  data(){
    return {
      list:[],//资料列表
      show:false,
      show2:false,
      loaded:false,
			page:1,
			pageCount:null,
			pagination:true,
			len:'',//课程数
			dataList:[],//资料列表
			papertitle:null,//试卷列表
    }
  },
  methods:{
    open(){
      this.$router.push({
        name:'MyCourse'
      })
    },
		getCoursePaperList(){//获取试卷列表
			this.show2 = true
			GetCoursePaperList({
				courseid:2163,
				page:1,
				pagesize:10,
				schoolid: SCHOOL_ID
			}).then(res=>{
				var paperList = JSON.stringify(res)


			})
		},
		getMyCourseList(p=1){//获取课程列表
			if(p==1){
				this.list = []
			}
			this.page = p
			GetMyCourseList({
				page:p,
				pagesize:1,
				schoolid: SCHOOL_ID
			}).then(res=>{
				this.list = this.list.concat(res.data)
				this.pageCount = res.totalcount
        this.len = res.data.length
        this.loaded = true
			})
    },
    //课程资料数据
		getCourseData(_courseid){
			this.show = true
			GetCourseDataList({
				courseid:_courseid,
				page:1,
				pagesize:10,
				schoolid: SCHOOL_ID
			}).then(res=>{

				this.dataList = res.data
			})
		}

  },
	created(){
		this.getMyCourseList()

	},
  activated(){
    document.title = '我的班级'
  }

}
</script>
<style scoped>
    .middlep{
      background-color:#fff;
      width: 100%;
      height:180px;
      margin-top:6px;
      border-radius: 10px;
    }
    .my-exam{
      height: 44px;
      background-color: #fff;
    }
    .my-exam__a{
      font-size: 16px;
      margin:0 10px 0 20px;
      line-height:40px;
      font-weight:bolder;
      color:rgba(51,51,51,1);
      margin-top:14.5px;
    }
    .my-exam__aa{
       font-size: 16px;
      margin:0 10px 0 20px;
      font-weight:bolder;
      color:rgba(251,110,82,1);
    }
    .mybox{
      margin-top: 10px;
      background-color: #fff;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
    .mybox-content{
      padding:15px;
    }
    .mybox-acous{
      font-size: 18px;
      font-weight:bold;
    }

    .mybox__item{
      display: flex
    }
    .bottom-btn{
      font-size: 12px;
      color: #fff;
      background:rgba(251,110,82,1);
      border-radius: 20px;
      border: 1px solid transparent;
      width: 45px;
      margin-top: -18px;
      margin-left: 10px;
      float:right;
    }
    .mybox-right{
      flex: 1;
      margin-top:10px;
    }
    .mybox-right__title{
      margin-top:11px;
      font-size:15px;
      font-weight:bold;
    }
    .mybox-right__teacher{
      margin-top: 5px;
      font-size:13px;
      color:rgba(153,153,153,1);
    }
    .mybox-right__percentage{
      margin-top:3px;
      margin-bottom:10px;
      font-size: 12px;
      color:rgba(153,153,153,1);
    }
    .mybox-img{
      width: 105px;
      height: 70px;
      margin-right:10px;
      margin-top: 20px;
      float: left;
			border-radius: 6px;
			overflow: hidden;
    }
		.mybox-img img{
			width: 100%;
			height: 100%;
		}
    .mylist-content__progress{
      margin-top:15px;
    }
    .mybox-right__hr{
      float: right;
      height: 0.5px;
      width: 66%;
      margin-top:5px;
      background:rgba(233,230,230,1);
    }
    .van-progress {
    height: 5px;
    position: relative;
    border-radius: 5px;
    background: #fddcdc;
    }
    .course-ast{
      text-align:center;
      line-height: 44px;
      font-size: 13px;
    }
    .course-ast_dload{
    right: 0;
    padding-top: 3px;
    padding-right: 15px;
    position: absolute;
    line-height: inherit;
    font-size: 18px;
    }
    .van-popup--bottom{
      border-radius: 10px 10px 0 0;
    }
    .van-actionsheet__header {
    font-size: 16px;
    line-height: 55px;
    text-align: center;
    font-weight: bold;
    }
    .ks-empty__img{
      margin-left: 4px;
      position:absolute;
      top: 16px;
      height: 50px;
    }
</style>





// WEBPACK FOOTER //
// src/pages/user/MyCourse.vue